import { useState } from 'react';

export enum TabType {
  CLOTHES = 'CLOTHES',
  SHOES = 'SHOES',
}

export const useSizeGuideService = () => {
  const [currentTab, setCurrentTab] = useState<TabType>(TabType.CLOTHES);

  const tabList = [
    {
      tab_type: TabType.CLOTHES,
      label: '의류',
    },
    {
      tab_type: TabType.SHOES,
      label: '신발',
    },
  ];

  return {
    tabList,
    currentTab,
    setCurrentTab,
  };
};
